import {Component, Input, OnDestroy, OnInit, HostListener} from '@angular/core';
import {GridOptions, RowDataUpdatedEvent} from 'ag-grid-community';
import {ButtonRendererComponent} from '../frt-rates-download/ButtonRendererComponent';
import _ from 'lodash';
import {HhgRateQueryService} from '../../services/hhg-rate-query/hhg-rate-query.service';
import {Router} from '@angular/router';
import {LoadingService} from '../../services/loading/loading.service';
import AppConstants, {
  agency_auditor_role,
  carrier_user,
  carrier_user_admin
} from '../../shared/common-components/AppConstants';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {User} from '../../services/user/user';
import {ISubscription} from 'rxjs-compat/Subscription';
import {UserService} from '../../services/user/user.service';
import {AlertService} from '../../services/alert/alert.service';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { formatDate } from '@angular/common';
import {UserPreferencesService} from '../../services/user-preferences/user-preferences.service';
import moment from 'moment';

@Component({
    selector: 'app-frt-query-results',
    templateUrl: './frt-query-results.component.html',
    styleUrls: ['./frt-query-results.component.css'],
    standalone: false
})
export class FrtQueryResultsComponent implements OnInit, OnDestroy {
  @Input() queryResults: Observable<any>;
  @Input() showGrid: Boolean;
  @Input() estimatedWeight: Number;
  @Input() numVehicles : Number;
  modalRef: BsModalRef;
  style = {
    width: '100%',
    height: '400px'
  };
  private observer$ = new BehaviorSubject(true);
  resultsSubscription = new Subscription();
  showGridResults = false;
  gridOptions: GridOptions = {
    rowSelection: 'multiple',
    defaultColDef: {
      sortable: true,
      resizable: true,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: true
      }
    },
    onRowDataUpdated: params => {
      this.gridApi = params.api;
      params.api.sizeColumnsToFit();
    },
    rowClassRules:{
      'frt-suspended-tsp' : function (params){
        return params.data.isTspSuspended;
      }
    },
    headerHeight: 50,
    pagination: true,
    cacheBlockSize: 25,
    overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    overlayNoRowsTemplate:
        '<span>No rows to display, please adjust your filters</span>'
  };
  private gridApi;
  private rowClassRules;
  subArr = [];
  columnsDefs: any;
  frameworkComponents: any;
  rowData: any;
  rowData1: any;
  currentUser: User | any;
  private user_subscription: ISubscription;
  @Input() userPrefList: any;
  @Input() screenName: any;
  @Input() showBody = false;
  @Input() pickupDate: any;
  @Input() estimatedMileage: any;
  userPrefBtnText: any;
  format = 'yyyy-MM-dd';
  locale = 'en-US';
  disabledDates;
  isPickupDatePastDate: boolean = false;
  /**
   * @description defines the button renderer component to show the smartWay button based on the flag.
   */
  constructor(private hhgRateQueryService: HhgRateQueryService, private userPreferencesService: UserPreferencesService,
              private modalService: BsModalService, private router: Router, private loader: LoadingService, private userService: UserService, private alertService: AlertService) {
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
    };
  }

  /**
   * initializing the ag-grid
   * @param params
   */
  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.gridApi.setDatasource(this.rowData);
  }


  calculateDeliveryDate(moveDate: any, miles: any, rateTypeId: any, sro: any) {
    if (AppConstants.isNotNullCondition(moveDate)) {
      /*const disabledDates = [new Date('2020-01-01 00:00:00'), new Date('2020-01-20 00:00:00'), new Date('2020-02-17 00:00:00'), new Date('2020-05-25 00:00:00'),
      new Date('2020-07-03 00:00:00'), new Date('2020-09-07 00:00:00'), new Date('2020-10-12 00:00:00'), new Date('2020-11-11 00:00:00'),
      new Date('2020-11-26 00:00:00'), new Date('2020-12-25 00:00:00'), new Date('2021-01-01 00:00:00'), new Date('2021-01-18 00:00:00'), new Date('2021-02-15 00:00:00'),
      new Date('2021-05-31 00:00:00'), new Date('2021-07-05 00:00:00'), new Date('2021-09-06 00:00:00'), new Date('2021-10-11 00:00:00'),
      new Date('2021-11-11 00:00:00'), new Date('2021-11-25 00:00:00'), new Date('2021-12-24 00:00:00'), new Date('2021-12-31 00:00:00'),
      new Date('2022-01-17 00:00:00'), new Date('2022-02-21 00:00:00'), new Date('2022-05-30 00:00:00'), new Date('2022-07-04 00:00:00'), new Date('2022-09-05 00:00:00'),
      new Date('2022-10-10 00:00:00'), new Date('2022-11-11 00:00:00'), new Date('2022-11-24 00:00:00'), new Date('2022-12-26 00:00:00'),
    ];*/
    const rateType = rateTypeId === 19 ? 'LTL' : 'TL';
    let daysToAdd = 0;
    if (rateType === 'LTL') {
      if (miles <= 500) {
        daysToAdd = 3;
      } else if (miles > 500 && miles <= 1000) {
        daysToAdd = 4;
      } else if (miles > 1000 && miles <= 1500) {
        daysToAdd = 5;
      } else if (miles > 1500 && miles <= 2000) {
        daysToAdd = 6;
      } else if (miles > 2000) {
        daysToAdd = 7;
      }
    } else if (rateType === 'TL' && sro !== 'GSSPR') {
      if (miles <= 500) {
        daysToAdd = 1;
      } else if (miles > 500 && miles <= 1000) {
        daysToAdd = 2;
      } else if (miles > 1000 && miles <= 1500) {
        daysToAdd = 3;
      } else if (miles > 1500 && miles <= 2000) {
        daysToAdd = 4;
      } else if (miles > 2000 && miles <= 2500) {
        daysToAdd = 5;
      } else if (miles > 2500) {
        daysToAdd = 6;
      }
    } else if (rateType === 'TL' && sro === 'GSSPR') {
      daysToAdd = 8;
    }
    const requiredDeliveryDate = new Date(moveDate.setHours(0, 0, 0, 0));
    return this.calcWorkingDays(requiredDeliveryDate, daysToAdd, this.disabledDates);
    }
  }

  calcWorkingDays(fromDate: any, days: any, disabledDates: any) {
    let count = 0;
    while (count < days) {
      fromDate.setDate(fromDate.getDate() + 1);
      const isHoliday: boolean = this.calculateBusinessDays(fromDate, disabledDates);
      if (fromDate.getDay() !== 0 && fromDate.getDay() !== 6 && !isHoliday) { // Skip weekends and holidays
        count++;
      }
    }
    return formatDate(fromDate, this.format, this.locale);
  }

  // skip holidays
  calculateBusinessDays(fromDate: any, disabledDates: any) {
    let value: any;
    disabledDates.forEach(x => {
      if (x.getTime() === fromDate.getTime()) {
        value = true;
      } else if (!value) {
        value = false;
      }
    });
    return value;
  }

  /**
   * @description manipulates row data according to the desired results and generates columns dynamically by looping through rowData.
   */
  ngOnInit() {
    this.loader.show();
    this.user_subscription = this.userService.getCurrentUserObservable().subscribe(currentUser => {
      this.currentUser = currentUser;
      this.loader.hide();
    }, error => {
      this.loader.hide();
      this.alertService.info('unable to get current user details');
    });
    this.isPickupDatePastDate = moment(moment(this.pickupDate).format('MM-DD-YYYY')).
            diff(moment(moment().format('MM-DD-YYYY')),'days') < 0;
    this.resultsSubscription = this.queryResults.subscribe(res => {
      this.userPreferencesService.getAllFederalHolidays().subscribe(holidays => {
        this.disabledDates = holidays.map(x => new Date(x + ' 00:00:00'));
      this.rowData1 = res;
      const data = [];
      if (res !== null && res !== undefined && res.length > 0) {
        this.showGrid = true;
        this.rowData1.forEach(x => {
          const obj = {
            scac: x.scac,
            scacName: x.scacName,
            currentYearOnTimePct: !x.currentYearOnTimePct ? '0.00' : Number(x.currentYearOnTimePct).toFixed(2).toString(),
            previousYearOnTimePct: !x.previousYearOnTimePct ? '0.00' : Number(x.previousYearOnTimePct).toFixed(2).toString(),
            currentYearOnTimePickUpPct: !x.currentYearOnTimePickUpPct ? '0.00' : Number(x.currentYearOnTimePickUpPct).toFixed(2).toString(),
            previousYearOnTimePickUpPct: !x.previousYearOnTimePickUpPct ? '0.00' : Number(x.previousYearOnTimePickUpPct).toFixed(2).toString(),
            smartWayId: x.smartWayId,
            socioEconomicInd: x.socioEconomicInd,
            totalCost: x.totalCost,
            rateType: x.rateType,
            fuelSurchargeCost: x.fuelSurchargeCost,
            linehaulCostFinal: x.linehaulCostFinal,
            freightQueryResults: x.freightQueryResults,
            phone: x.phone,
            email: x.email,
            //add a comment
            // rateType: x.rateTypeId === 19 ? 'LTL' : 'TL',
            sro: x.sro,
            tenderId: x.tenderId,
            estimatedCost: x.tlCostFinal < x.ltlCostFinal ? x.tlCostFinal : x.ltlCostFinal,
            queryId: x.queryId,
            rateId: x.rateId,
            baseChargeFinal: x.baseChargeFinal,
            carrierId: x.carrierId,
            expectedDeliveryDate: this.calculateDeliveryDate(this.pickupDate, this.estimatedMileage, x.rateTypeId, x.sro),
            estimatedWeight : this.estimatedWeight,
            numberOfVehicles: this.numVehicles,
            isTspSuspended: x.isTspSuspended,
            tspOfferings: x.tspOfferings
          };
          data.push(obj);
        });
        this.rowData = data;
        if (this.rowData.length <= 10) {
          this.setHeightSmallData();
        } else {
          this.setHeightLargeData();
        }
        this.columnsDefs = this.generateColumns(this.rowData);
        // this.gridApi.setDatasource(this.rowData);
      } else {
        this.showGrid = false;
      }
    });
    });
    this.loader.hide();
  }

  setHeightSmallData() {
    this.setWidthAndHeight('100%', '100px');
  }

  setHeightLargeData() {
    this.setWidthAndHeight('100%', '400px');
  }
  setWidthAndHeight(width: any, height: any) {
    this.style = {
        width: width,
        height: height
    };
  }

  /**
   * @description generates columns dynamically by looping through the grid data. Gets the unique columns from freightQuery results array
   * and loops through it to generate them as dynamic columns.
   * @returns { any[] }
   */
  generateColumns(data) {
    let columnDefinitions = [];
    this.subArr = [];
    
    // Extract unique accessorials from freight query results
    data.map(object => {
      if (object.freightQueryResults !== null && object.freightQueryResults !== undefined && object.freightQueryResults.length > 0) {
        object.freightQueryResults.forEach(obj => {
          this.subArr.push(obj);
        });
      }
    });
    this.subArr = _.uniqBy(this.subArr, 'accessorialCode');

    // Define columns in the specific order
    // 1. SCAC
    columnDefinitions.push({
      headerName: 'SCAC',
      field: 'scac',
      minWidth: 80,
      cellRenderer: params => {
        if (AppConstants.isNotNullCondition(params) &&
            (!this.checkUserRole(carrier_user) && !this.checkUserRole(carrier_user_admin) &&
             !this.checkUserRole(agency_auditor_role) &&
             !this.checkUserRole(carrier_user_admin)) &&
             !params.data.isTspSuspended &&
             (moment(moment(this.pickupDate).format('MM-DD-YYYY')).
                       diff(moment(moment().format('MM-DD-YYYY')),'days') >= 0)) {
          return '<a tabindex="0">' + params.data.scac + '</a>';
        } else {
          return params.data.scac;
        }
      },
      onCellClicked: event => (!this.checkUserRole(carrier_user) &&
                                !this.checkUserRole(carrier_user_admin) &&
                                !this.checkUserRole(carrier_user_admin) &&
                                !this.checkUserRole(agency_auditor_role)  &&
                                (moment(moment(this.pickupDate).format('MM-DD-YYYY')).
                                  diff(moment(moment().format('MM-DD-YYYY')),'days') >= 0)) ?
                                    this.onFrtRateQuerySelected(event.data) : null
    });

    // 2. TSP Name
    columnDefinitions.push({
      headerName: 'TSP Name',
      field: 'scacName',
      minWidth: 250
    });

    // 3. Email
    columnDefinitions.push({
      headerName: 'Email',
      field: 'email',
      minWidth: 180
    });

    // 4. Phone
    columnDefinitions.push({
      headerName: 'Phone',
      field: 'phone',
      minWidth: 120
    });

    // 5. Total Cost
    columnDefinitions.push({
      headerName: 'Total Cost',
      field: 'totalCost',
      minWidth: 100,
      valueFormatter: this.formatNumber
    });

    // 6. Linehaul Cost
    columnDefinitions.push({
      headerName: 'Linehaul Cost',
      field: 'linehaulCostFinal',
      minWidth: 100,
      valueFormatter: this.formatNumber
    });

    // 7. Fuel Surcharge Cost
    columnDefinitions.push({
      headerName: 'Fuel Surcharge Cost',
      field: 'fuelSurchargeCost',
      minWidth: 150,
      valueFormatter: this.formatNumber
    });

    // 8. Accessorial columns (dynamic)
    if (this.subArr.length > 0) {
      for (let i = 0; i < this.subArr.length; i++) {
        columnDefinitions.push({
          headerName: this.subArr[i].accessorialCode,
          minWidth: 100,
          maxWidth: 120,
          valueGetter: params => params.data.freightQueryResults[i] !== null && params.data.freightQueryResults[i] !== undefined  ? ('$' + params.data.freightQueryResults[i].estimatedCost) : null,
        });
      }
    }

    // 9. Estimated Weight
    columnDefinitions.push({
      headerName: 'Estimated Weight',
      field: 'estimatedWeight',
      minWidth: 100
    });

    // 10. Socio Economic Ind
    columnDefinitions.push({
      headerName: 'Socio Economic Ind',
      field: 'socioEconomicInd',
      minWidth: 120
    });

    // 11. SmartWay
    columnDefinitions.push({
      headerName: 'SmartWay',
      field: 'smartWayId',
      minWidth: 100,
      cellStyle: {'text-align': 'center'},
      cellRenderer: params =>
          params.data.smartWayId
              ? '<svg class="usa-icon define-text-green define-size-leaf" aria-hidden="true" focusable="false" role="img"><use xlink:href="/assets/uswds/img/sprite.svg#eco"></use></svg>'
              : ''
    });

    // 12. Rate Type
    columnDefinitions.push({
      headerName: 'Rate Type',
      field: 'rateType',
      minWidth: 100
    });

    // 13. SRO Id
    columnDefinitions.push({
      headerName: 'SRO Id',
      field: 'sro',
      minWidth: 80
    });

    // 14. Tender Id
    columnDefinitions.push({
      headerName: 'Tender Id',
      field: 'tenderId',
      minWidth: 100
    });

    // 15. Expected Delivery Date
    columnDefinitions.push({
      headerName: 'Expected Delivery Date',
      field: 'expectedDeliveryDate',
      minWidth: 150
    });

    // 16. Current CY Year On-Time Pick Up %
    columnDefinitions.push({
      headerName: 'Current CY Year On-Time Pick Up %',
      field: 'currentYearOnTimePickUpPct',
      minWidth: 180
    });

    // 17. Current CY Year On-Time Delivery %
    columnDefinitions.push({
      headerName: 'Current CY Year On-Time Delivery %',
      field: 'currentYearOnTimePct',
      minWidth: 180
    });

    // 18. Previous CY Year On-Time Pick Up %
    columnDefinitions.push({
      headerName: 'Previous CY Year On-Time Pick Up %',
      field: 'previousYearOnTimePickUpPct',
      minWidth: 180
    });

    // 19. Previous CY Year On-Time Delivery %
    columnDefinitions.push({
      headerName: 'Previous CY Year On-Time Delivery %',
      field: 'previousYearOnTimePct',
      minWidth: 180
    });

    // Add TSP Offerings column
    columnDefinitions.push({
      headerName: 'TSP Offerings',
      field: 'tspOfferings',
      minWidth: 120
    });

    // Add hidden columns for internal use
    columnDefinitions.push({
      headerName: 'Query Id',
      field: 'queryId',
      minWidth: 100,
      hide: true
    });

    columnDefinitions.push({
      headerName: 'Rate Id',
      field: 'rateId',
      minWidth: 100,
      hide: true
    });

    columnDefinitions.push({
      headerName: 'Estimated Cost',
      field: 'estimatedCost',
      minWidth: 100,
      hide: true
    });

    columnDefinitions.push({
      headerName: 'Base Charge Final',
      field: 'baseChargeFinal',
      minWidth: 100,
      hide: true
    });

    columnDefinitions.push({
      headerName: 'Carrier Id',
      field: 'carrierId',
      minWidth: 100,
      hide: true
    });

    columnDefinitions.push({
      headerName: 'Is TSP Suspended',
      field: 'isTspSuspended',
      minWidth: 100,
      hide: true
    });

    columnDefinitions.push({
      headerName: 'Number of Vehicles',
      field: 'numberOfVehicles',
      minWidth: 100,
      hide: true
    });

    console.log('Final Columns', columnDefinitions);
 
    // Apply user preferences for column visibility
    if (this.userPrefList && this.userPrefList.length > 0) {
        columnDefinitions.forEach(col => {
          this.userPrefList.forEach(pref => {
            if ((pref.field === col.field) && (!pref.isVisible)) {
              col.hide = true;
            }
        });
      });
    }
    
    return columnDefinitions;
  }
  /*
   * @description will get executed when clicks on scac hyperlink from the table.
   * @param data: grid row data
    when frt rate query result is selected, then save bookshipment and redirect to
    frtbookshipment component with response
 */
  onFrtRateQuerySelected(frtRateSelectedItem) {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, you want to continue with the selection';
    this.modalRef.content.title = 'FRT Query Item Selection';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.loader.show();
        frtRateSelectedItem.queryType = 'FRT';
        this.hhgRateQueryService.saveBookShipmentDetailsForHHGRateQuery(frtRateSelectedItem).subscribe(bookshipmentid => {
          this.loader.hide();
          if (AppConstants.isNotNullCondition(bookshipmentid)) {
            this.router.navigate(['/', 'frtbookshipment'],
                {queryParams: {bookshipmentid: bookshipmentid}});
          }
        }, error => {
          this.loader.hide();
        });
      }
    });
  }

  /**
   * @description exports all the grid data from the datasource into a csv file using ag-grid api
   */
  // onBtExport() {
  //   const date = new Date();
  //   const params = {
  //     fileName: 'freight-query-results-report-' + date + '.csv',
  //     columnSeparator: ','
  //   };
  //   this.gridApi.exportDataAsCsv(params);
  // }

  /**
   *
   * @param: roles
   * @returns: {boolean}
   */
  checkUserRole(roles?) {
    if (this.currentUser) {
      const userRoles = _.map(this.currentUser.roles, x => x.role);
      if (userRoles && userRoles.length > 0) {
        return _.includes(userRoles, roles);
      }
    }
  }

  onBtPrint() {
    const api = this.gridApi;
    setPrinterFriendly(api);
    setTimeout(function () {
      print();
      setNormal(api);
    }, 2000);
  }


  /**
   * @description formats the value into comma seperator number (in thousands place) and adds $ sign to it.
   * @param params
   */
  formatNumber(params) {
    const number = params.value;
    const parts = params.value.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
    // return '$' + Math.floor(number).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  formatDecimalNumber(params) {
    const number = params.value;
    return Number(number).toFixed(2);
  }

  updateListPrefs(listPref: any) {
    this.userPrefList = listPref;
    this.columnsDefs = this.generateColumns(this.rowData);
  }

  showHideColumnsBasedOnPrefs() {
    if (this.userPrefList && this.userPrefList.length > 0) {
      this.columnsDefs.forEach(col => {
        this.userPrefList.forEach(pref => {
          if ((pref.field === col.field) && (!pref.isVisible)) {
            col.hide = true;
          }
        });
      });
    }
  }
  gotoUserPrefs() {
    this.showBody = true;

  }

  closeUserPrefs() {
    this.showBody = false;
  }

  @HostListener('window:beforeprint') onBeforePrint() {
    let timer;
    const api = this.gridApi;
    modifytableBeforePrint(api);
    setPrinterFriendly(api);
    () => {
      timer = setTimeout(() => {
        print();
        clearTimeout(timer);
      }, 2000);
    };
  }

  @HostListener('window:afterprint') onAfterPrint() {
    const api = this.gridApi;
    setNormal(api);
  }

  ngOnDestroy(): void {
    this.resultsSubscription.unsubscribe();
    if (this.user_subscription) {
      this.user_subscription.unsubscribe();
    }
  }

}

function modifytableBeforePrint(api) {
  const eGridDiv = document.getElementById('myGrid');
  if (api.getDisplayedRowCount() <= 10) {
    eGridDiv.style.height = '200px';
  } else {
    eGridDiv.style.height = '400px';
  }
  eGridDiv.style.width = '1400px';
}

function setPrinterFriendly(api) {
  const eGridDiv = document.getElementById('myGrid');
  eGridDiv.style.height = '';
  api.setDomLayout('print');
}

function setNormal(api) {
  const eGridDiv = document.getElementById('myGrid');
  eGridDiv.style.width = '100%';
  if (api.getDisplayedRowCount() <= 10) {
    eGridDiv.style.height = '200px';
  } else {
    eGridDiv.style.height = '400px';
  }
  api.setDomLayout(null);
}
